export const PAGES = {
  SERVICE: "/service/:id/",
  SERVICES: "/services/:id/",
  BOOKING: "/booking/:id/",
  BOOKING_CONFIRMATION: "/booking/:id/confirmation",
  TERMS: "/terms/",
  PRIVACY: "/privacy/",
  RESCHEDULE: "/reschedule/:id/",
};
